@if (showNav && isAuthenticated) {
  <app-nav-top-bar></app-nav-top-bar>
}

<mat-sidenav-container class="principal-container" autosize="true">
  @if (showNav && isAuthenticated) {
    <mat-sidenav class="menu-sidenav" mode="side" opened="true">
      <app-nav-menu></app-nav-menu>
    </mat-sidenav>
  }
  <div class="principal-sidenav-content">
    <router-outlet></router-outlet>
  </div>
</mat-sidenav-container>
